<template>
  <div class="helpWarningBox">
    <div class="helpcloginCon">
       <div class="bigTitle" @click="backFn('showa')"><span ></span>创建预警</div>
      <div class="smallTile" v-for="(item,index) in flowList" v-if="showa">
        <p>{{item.con}} </p>
        <img :src="item.img" v-if="item.img!=''">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      showa:true,
      flowList:[
        {
          con:'1.预警提醒-新增预警',
          img:require('../../../assets/images/helpCenter/cjyj.png')
        },
        {
          con:'2.合同名称填写未完成签署的待他人签的合同',
          img:''
        },
        {
          con:'3.填写预警名称',
          img:''
        },
        {
          con:'4.选择预警时间',
          img:''
        },
        {
          con:'5.填写预警事件',
          img:''
        },
        {
          con:'6.选择消息接收方',
          img:''
        },
        {
          con:'7.选择通知方式',
          img:''
        },
        {
          con:'8.点击提交，创建预警成功',
          img:''
        }
      ]
    }
  },
  methods:{
    backFn(flag){
      if(this[flag]==true){
        this[flag]=false;
      }else{
        this[flag]=true;
      }
    }
  }
  
}
</script>